import React, { useState } from 'react';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import LoaderButton from '../components/LoaderButton';
import './Activate.css';
import { postActivateAccount, patchUser } from '../utils/bedrockAPI';

export default function Activate(props) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  function validateForm() {
    if (password.length < 8 || confirmPassword !== password) {
      return false;
    }
    if (firstName.length === 0 || lastName.length === 0) {
      return false;
    }
    return true;
  }

  async function handleAccountActivation(event) {
    event.preventDefault();
    setIsLoading(true);
    try {
      const decodedHash = decodeURIComponent(props.match.params.hash);
      const token = await postActivateAccount(
        props.match.params.userid,
        decodedHash,
        password
      );
      const addUsersName = { firstName, lastName };
      await patchUser(props.match.params.userid, addUsersName, token);
      props.history.push(`/caps/${props.match.params.capid}`);
    } catch (e) {
      props.setShowError(true);
      props.setErrorStatus('error-message');
      props.setErrorMessage(
        'Authorization link invalid. Please use the latest activation email from Bedrock Wireless.'
      );
    }
    setIsLoading(false);
  }

  return (
    <div className="activate-page">
      <header className="activate-header">
        <h1>Activate Your Account</h1>
        <p className="activate-subtitle">
          Complete your profile and set a password to access your Bedrock Wireless cameras.
          You will need to log in after activation.
        </p>
      </header>

      <div className="activate-panel">
        <form className="activate-form" onSubmit={handleAccountActivation}>
          <FormGroup controlId="firstName">
            <ControlLabel>First Name</ControlLabel>
            <FormControl
              autoFocus
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
            />
          </FormGroup>
          <FormGroup controlId="lastName">
            <ControlLabel>Last Name</ControlLabel>
            <FormControl
              value={lastName}
              onChange={e => setLastName(e.target.value)}
            />
          </FormGroup>
          <FormGroup controlId="password">
            <ControlLabel>Password</ControlLabel>
            <FormControl
              value={password}
              type="password"
              autoComplete="new-password"
              onChange={e => setPassword(e.target.value)}
            />
          </FormGroup>
          <FormGroup controlId="confirmPassword">
            <ControlLabel>Confirm Password</ControlLabel>
            <FormControl
              value={confirmPassword}
              type="password"
              autoComplete="new-password"
              onChange={e => setConfirmPassword(e.target.value)}
            />
          </FormGroup>
          <p className="activate-hint">Password must be at least 8 characters.</p>
          <div className="activate-actions">
            <LoaderButton
              type="submit"
              className="btn-brand-dark btn-compact"
              isLoading={isLoading}
              disabled={!validateForm()}
            >
              Activate Account
            </LoaderButton>
          </div>
        </form>
      </div>
    </div>
  );
}
